import ExpandableButton from "@visiblethread/react-components/dist/components/ExpandableButton";
import { useSelector } from "react-redux";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useState } from "react";
import { sortObjectArrayComparator } from "utils";
import { ReactComponent as ArrowUp } from "icons/dictionary/ArrowUp.svg";
import { ReactComponent as ArrowDown } from "icons/dictionary/ArrowDown.svg";
import { selectDiscoveryIgnore } from "slices/settings/selectors";

const fields = {
  term: "term",
  freq: "occurrences",
};

const IgnoreList = () => {
  const { ignoreListWithFreq: ignoreList } = useSelector(selectDiscoveryIgnore);

  const [sortOptions, setSortOptions] = useState({
    asc: false,
    field: fields.freq,
  });

  const rows = () => {
    return ignoreList
      .toSorted(sortObjectArrayComparator(sortOptions.asc, sortOptions.field))
      .map((term) => (
        <div>
          <span>{term.term}</span>
          <span>{term.occurrences}</span>
        </div>
      ));
  };

  const sortFields = (field) => {
    let asc = true;
    if (sortOptions.field === field) {
      asc = !sortOptions.asc;
    } else if (field === fields.freq) {
      asc = false;
    }

    setSortOptions({ field, asc });
  };

  const handleTermClick = () => {
    sortFields(fields.term);
  };
  const handleFreqClick = () => {
    sortFields(fields.freq);
  };

  const showNumbersArrow = () =>
    sortOptions.asc ? (
      <ArrowUp width={9} height={9} />
    ) : (
      <ArrowDown width={9} height={9} />
    );

  const showStringsArrow = () =>
    sortOptions.asc ? (
      <ArrowDown width={9} height={9} />
    ) : (
      <ArrowUp width={9} height={9} />
    );

  const modalHeader = () => (
    <div className="ignore_list_modal__header">
      <button
        onClick={handleTermClick}
        type="button"
        className={sortOptions.field === fields.term ? "sorted" : ""}
      >
        Term
        {showStringsArrow()}
      </button>
      <button
        onClick={handleFreqClick}
        type="button"
        className={sortOptions.field === fields.freq ? "sorted" : ""}
      >
        Occurrences
        {showNumbersArrow()}
      </button>
    </div>
  );

  const listContent = () => {
    return (
      <div className="ignore_list_modal">
        {modalHeader()}
        <div
          className={`ignore_list_modal__terms${ignoreList.length > 4 ? " scroll" : ""}`}
        >
          {rows()}
        </div>
        <Button
          onClick={() => {
            window.location.href = "/settings/#/discovery";
          }}
          variant={buttonVariants.secondary}
          content="View Full Ignore List"
        />
      </div>
    );
  };

  return (
    <ExpandableButton
      buttonText={`Ignored Terms (${ignoreList.length})`}
      content={listContent()}
      disabled={ignoreList.length === 0}
    />
  );
};

export default IgnoreList;
